// Add your custom JS here.
; (function ($) {
    $(document).ready(function () {
        new AOS.init();

        if ($('[data-fancybox]').length) {
            $('[data-fancybox]').fancybox();
        }

        if ($('.slider').length) {
            var slider = new Swiper(".slider", {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed: 500,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                }
            });
        }

        if ($('.houseFinish__slider').length) {
            $('.houseFinish__slider').each(function () {
                // Khởi tạo Swiper cho từng phần tử
                var houseFinishSlider = new Swiper(this, {
                    // Cấu hình Swiper theo ý muốn
                    slidesPerView: 1,
                    // Thêm các cấu hình khác nếu cần
                    navigation: {
                        nextEl: '.swiper-button-next',  
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                    },
                });
            });
        }

        if ($('.designGallery__slider').length) {
            $('.designGallery__slider').each(function () {
                // Khởi tạo Swiper cho từng phần tử
                var designGallerySlider = new Swiper(this, {
                    // Cấu hình Swiper theo ý muốn
                    slidesPerView: 1,
                    // Thêm các cấu hình khác nếu cần
                    navigation: {
                        nextEl: '.swiper-button-next',  
                        prevEl: '.swiper-button-prev',
                    },
                });
            });
        }

        if ($('.newspapers__slider').length) {
            var newspapers__slider = new Swiper(".newspapers__slider", {
                slidesPerView: 4,
                spaceBetween: 24,
                speed: 500,
                loop: false,
                navigation: {
                    nextEl: ".newspapers__slider .swiper-button-next",
                    prevEl: ".newspapers__slider .swiper-button-prev",
                },// Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    960: {
                        slidesPerView: 4,
                    }
                }
            });
        }

        if ($('.bdHouseExp__slider').length) {
            var bdHouseExp__slider = new Swiper(".bdHouseExp__slider", {
                slidesPerView: 3.2,
                spaceBetween: 15,
                speed: 500,
                loop: false,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    960: {
                        slidesPerView: 3.2,
                    }
                }
            });
        }

        if ($('.photoRealistic__list .photo').length > 15) {
            $('.photoRealistic__list .photo:nth-child(15)').nextAll().hide();
            $('.photoRealistic__list').after('<button type="button" class="viewmorePhoto">Xem thêm</button>');
            $(document).on('click', '.viewmorePhoto', function (e) {
                e.preventDefault();
                if ($(this).hasClass('show')) {
                    $(this).removeClass('show').text('Xem thêm')
                        .siblings('.photoRealistic__list').removeClass('show')
                        .find('.photo:nth-child(15)').nextAll().slideUp(300).hide(300);
                } else {
                    $(this).addClass('show').text('Ẩn bớt').siblings('.photoRealistic__list').addClass('show').find('.photo:nth-child(15)').nextAll().slideDown(300).show(300);
                }
            });
        }

        if ($('.singleHouse__images').length) {
            var singleHouse__thumbs = new Swiper(".singleHouse__thumbs", {
                direction: "vertical",
                spaceBetween: 16,
                slidesPerView: 3,
                navigation: {
                    nextEl: ".singleHouse__thumbs .swiper-button-next",
                    prevEl: ".singleHouse__thumbs .swiper-button-prev",
                },
                watchSlidesProgress: true,
            });
            var singleHouse__images = new Swiper(".singleHouse__images", {
                spaceBetween: 10,
                effect: 'fade',
                thumbs: {
                    swiper: singleHouse__thumbs,
                },
            });
        }

        if ($('.houseRelatedSlider').length) {
            var houseRelatedSlider = new Swiper(".houseRelatedSlider", {
                slidesPerView: 4,
                spaceBetween: 24,
                speed: 500,
                loop: false,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    960: {
                        slidesPerView: 3.2,
                    }
                }
            });
        }
        if ($('.newsRelated__slider').length) {
            var newsRelated__slider = new Swiper(".newsRelated__slider", {
                slidesPerView: 4,
                spaceBetween: 24,
                speed: 500,
                loop: false,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    960: {
                        slidesPerView: 3.2,
                    },
                    1080: {
                        slidesPerView: 4
                    }
                }
            });
        }
        if ($('.recentlyViewed__list').length) {
            var recentlyViewedList = new Swiper(".recentlyViewed__list", {
                slidesPerView: 4,
                spaceBetween: 24,
                speed: 500,
                loop: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    960: {
                        slidesPerView: 3.2,
                    },
                    1080: {
                        slidesPerView: 4
                    }
                }
            });
        }
        
        if ($('.houseExpVideo').length) {
            var houseExpVideo = new Swiper(".houseExpVideo", {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed: 500,
                loop: true,
                autoplay: {
                    delay: 5000,
                }
            });
        }

        $('.houseExpFeature__nav > .nav').on('click', function(e) {
            e.preventDefault();

            $(this).addClass('active').siblings('.nav').removeClass('active');
            const termId = parseInt($(this).data('term'));

            $.ajax({
                type: 'post',
                url: "/wp-admin/admin-ajax.php",
                dataType: 'JSON',
                data: {
                    action: "get_exphouse_by_term",
                    termId
                },
                beforeSend: function () {
                    $('.houseExpTabList').empty().append('<div class="loading"></div>');
                },
                success: function (data) {
                    if (data) {
                        $('.houseExpTabList').empty().html(data);
                    }else {
                        $('.houseExpTabList').empty().html('<p class="text-center">Chưa có bài viết</p>');
                    }
                }
            });
        });
        
        $('.navNews').on('click', function(e) {
            e.preventDefault();
            const term = $(this).data('cate');
            $(this).addClass('active').siblings('.active').removeClass('active');

            loadContent('.newsList', '.pagination', term, 1);
        });
        
        $('.newsMain').on('click', 'a.page-numbers', function(e) {
            e.preventDefault();
            const term = $('.navNews.active').data('cate');
            let paged = 1;

            if($(this).hasClass('next') || $(this).hasClass('prev')) {
                const dataPage = $(this).find('i').data('page');
                paged = parseInt(dataPage);
            }else {
                paged = parseInt($(this).text())
            }

            loadContent('.newsList', '.pagination', term, paged);
        });

        function loadContent(contentWrap, paginationWrap, term = 0, paged = 1) {
            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                dataType: "JSON",
                data: {
                    action: "load_posts_news",
                    term: term,
                    current_page: paged
                },
                beforeSend: function() {
                    $(contentWrap).css('min-height',$(contentWrap).outerHeight());
                    $(contentWrap).empty().append('<div class="loading"></div>');
                },
                success: function(data) {
                    if(data) {
                        $(contentWrap).empty().html(data.posts);
                        $(contentWrap).css('min-height','unset');
                        $(paginationWrap).html(data.pagination);
                    }
                },
            });
        }
        $('#shareFb').on('click', function(e) {
            e.preventDefault();
            // URL của trang bạn muốn chia sẻ
            var urlToShare = encodeURIComponent(window.location.href);

            // Tạo URL chia sẻ Facebook với thông tin cần thiết
            var facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + urlToShare;

            // Mở cửa sổ mới chia sẻ Facebook
            window.open(facebookShareUrl, '_blank', 'width=600,height=400');
        });

        setTimeout(function() {
            checkHeight('.packageInfo__price');
            checkHeight('.designPackage__head');
            checkHeight('.designPackage__price');
            checkHeight('.designPackage__idea');
            checkHeight('.designPackage__perspective');
            checkHeight('.designPackage__waterElectric');
            checkHeight('.designPackage__projectEstimate');
            checkHeight('.designPackage__fengShui');
        });

        if($('.materialPackage').length) {
            $('.materialPackage').each(function() {
                const packageHeight = $(this).outerHeight();
                if(packageHeight > 768) {
                    $(this).addClass('less').after('<button type="button" class="showMorePackage">Xem thêm</button>');
                }
            });

            $(document).on('click', '.showMorePackage', function(e) {
                e.preventDefault();
                if($(this).hasClass('show')) {
                    $(this).text('Xem thêm').removeClass('show').siblings('.materialPackage').addClass('less');
                }else {
                    $(this).text('Ẩn bớt').addClass('show').siblings('.materialPackage').removeClass('less');
                }
            });
        }

    });
    function checkHeight(selector) {
        let height = 0;
        if($(selector).length) {
            $(selector).each(function() {
                let newHeight = $(this).outerHeight();
                if(newHeight > height) {
                    height = newHeight;
                }
            });

            $(selector).css('height', height+'px');
        }
    }
    function checkWidth(selector) {
        let width = 0;
        if($(selector).length) {
            $(selector).each(function() {
                let newWidth = $(this).outerWidth();
                if(newWidth > width) {
                    width = newWidth;
                }
            });

            $(selector).css('width', width+'px');
        }
    }
})(jQuery);